import iconExcelGrey from '@assets/img/icon_excel_grey.svg';
import iconExternalLink from '@assets/img/icon_external_link.svg';
import iconPdf from '@assets/img/icon_pdf.svg';
import iconPowerpointGrey from '@assets/img/icon_powerpoint_grey.svg';
import iconWord from '@assets/img/icon_word.svg';
import settings from '@config/settings';
import PhotoIcon from '@mui/icons-material/Photo';

import { getAttachmentName } from '@store/calendar/calendarVMHelper';
import type { ApiAttachment } from '../../../types/llinkidApiTypes';
import './attachment.scss';

type AttachmentItem = ApiAttachment['$$expanded'] & {
  type?: string;
};

const getAttachmentUrl = (att: AttachmentItem): string => {
  let url = att.href;
  if (!att.href.includes('http')) {
    url = settings.apisAndUrls.api + att.href;
  }

  return url;
};

const getCustomSvgIcon = (type: string): string => {
  const ICONS: Record<string, string> = {
    'application/pdf': iconPdf,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': iconWord,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': iconExcelGrey,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': iconPowerpointGrey,
  };

  return ICONS[type] || iconExternalLink;
};

interface AttachmentProps {
  item: AttachmentItem;
}

const Attachment = ({ item }: AttachmentProps) => {
  const url = getAttachmentUrl(item);
  const name = getAttachmentName(item);

  let inferredContentType = item.contentType || '';
  if (inferredContentType === '') {
    if (name.includes('xlsx')) {
      inferredContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (name.includes('pptx')) {
      inferredContentType =
        'application/vnd.openxmlformats-officedocument.presentationml.presentation';
    }
  }

  const type = inferredContentType || item.type || '';
  const isImage = type.startsWith('image/');

  return (
    <div className="attachment">
      <a href={url} target="_blank" rel="noreferrer" onClick={(ev) => ev.stopPropagation()}>
        {isImage && <PhotoIcon className="image-icon" />}
        {!isImage && (
          <div className="icon">
            <img src={getCustomSvgIcon(type)} alt="" />
          </div>
        )}
        <div className="name">{name}</div>
      </a>
    </div>
  );
};

export default Attachment;
